module.exports = __webpack_public_path__ + "img/doodle_jump_detail.ca01c14d.png";